//.btn-gnaviはメニューの三本線
document.addEventListener('DOMContentLoaded', () => {
  $(".btn-gnavi").on("click", function () {
    // ハンバーガーメニューの位置を設定
    var rightVal = 0;
    if ($(this).hasClass("open")) {
      // 位置を移動させメニューを開いた状態にする
      rightVal = -300;
      // メニューを開いたら次回クリック時は閉じた状態になるよう設定
      $(this).removeClass("open");
    } else {
      // メニューを開いたら次回クリック時は閉じた状態になるよう設定
      $(this).addClass("open");
    }
    $("#global-navi").stop().animate({
      right: rightVal
    }, 200);
  });

  $(".btn-gnavi").on("click", function () {
    if ($(this).hasClass("open")) {
      $("#nav-close").addClass("block");
    } else {
      // メニューを開いたら次回クリック時は閉じた状態になるよう設定
      $("#nav-close").removeClass("block");
    }
  });

  //#nav-closeはグレーの膜
  $("#nav-close").on("click", function () {
    // ハンバーガーメニューの位置を設定
    var rightVal = 0;
    if ($(".btn-gnavi").hasClass("open")) {
      // 位置を移動させメニューを開いた状態にする
      rightVal = -300;
      // メニューを開いたら次回クリック時は閉じた状態になるよう設定
      $(".btn-gnavi").removeClass("open");
      $("#nav-close").removeClass("block");
    } else {
      // メニューを開いたら次回クリック時は閉じた状態になるよう設定
      $(".btn-gnavi").addClass("open");
      $("#nav-close").addClass("block");
    }
    $("#global-navi").stop().animate({
      right: rightVal
    }, 200);
  });

  $(window).on('load scroll', function () {
    var scroll = $(window).scrollTop();
    var winsize = $(window).width();

    if (winsize > 1024) {
      if (scroll > 600) {
        $('header').fadeOut(300);
        //$('header ').fadeIn(800);
        //$('header .h-content').addClass('heightfix');
      } else {
        $('header').fadeIn(600);
        //$('header ').fadeOut(200);
        //$('header .h-content').removeClass('heightfix');
      }
    }
  });
});
